var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('transition',{attrs:{"name":"slide"}},[(_vm.show)?_c('div',{staticClass:"flag-form-container",class:{ show: _vm.show }},[_c('flag-form',{attrs:{"video-id":_vm.videoId}})],1):_vm._e()])],1)}
var staticRenderFns = []

export { render, staticRenderFns }